module.exports = __webpack_public_path__ + "img/arrow-expand.d1772067.svg";